import React from 'react';

import { FormulaDetailModel } from 'models/formula.model';

import { SummaryItem } from './SummaryItem';

export const AlternateMessagesSummary = ({
    formula,
}: {
    formula: FormulaDetailModel;
}) => {
    return (
        <SummaryItem label="Alternate Messages" value={formula.message_count} />
    );
};
